import styled from 'styled-components';

/**
 * Layout for the shared page-level skeletons.
 *
 * Follows the same conventions as the Contacts and Tasks skeletons: --hd-*
 * tokens only, and the reference's radius scale (--radius: 0.875rem):
 *   sm 10 - md 12 - lg 14 - xl 18 - 2xl 22 - full 999
 *
 * Careful: a backtick inside a CSS comment ends the template literal early and
 * the module throws on load. Keep comments backtick-free.
 */

const BORDER = 'var(--hd-border)';
const CARD = 'var(--hd-card)';
const MUTED_40 = 'color-mix(in srgb, var(--hd-muted) 40%, transparent)';

export const StyledPageSkeleton = styled.div`
  width: 100%;

  .sk-page {
    width: 100%;
    max-width: ${({ $maxWidth }) => $maxWidth || '1480px'};
    margin: 0 auto;
    padding: ${({ $padded }) => ($padded ? '32px 24px' : '0')};

    @media (max-width: 767px) {
      padding: ${({ $padded }) => ($padded ? '24px 16px' : '0')};
    }
  }

  .sk-stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 32px;

    @media (max-width: 1023px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 599px) {
      grid-template-columns: 1fr;
    }
  }

  .sk-stat {
    padding: 20px;
    border: 1px solid ${BORDER};
    border-radius: 22px;
    background: ${CARD};
  }

  .sk-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .sk-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border: 1px solid ${BORDER};
    border-radius: 22px;
    background: ${CARD};
  }

  .sk-row-lines {
    flex: 1;
    min-width: 0;
  }

  /* Table variant — header strip plus evenly spaced rows. */
  .sk-table {
    overflow: hidden;
    border: 1px solid ${BORDER};
    border-radius: 22px;
    background: ${CARD};
  }

  .sk-thead {
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns || 5}, minmax(0, 1fr));
    gap: 16px;
    padding: 14px 20px;
    background: ${MUTED_40};
  }

  .sk-trow {
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns || 5}, minmax(0, 1fr));
    gap: 16px;
    align-items: center;
    padding: 18px 20px;
    border-top: 1px solid ${BORDER};
  }

  .sk-section {
    padding: 20px;
    margin-bottom: 16px;
    border: 1px solid ${BORDER};
    border-radius: 22px;
    background: ${CARD};
  }

`;
